import { Box, LinearProgress, LoadingSpinner } from './style';
import { useLoadingProgress } from '@/hooks/useLoadingProgress';

export const LoadingProgress = ({ showSpinner = false, showBar = true }) => {
  const { loadingProgress, loadingStep } = useLoadingProgress();

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {loadingProgress > 0 && showBar && (
        <Box className="d-flex flex-column align-items-center justify-content-center mb-3">
          <span style={{ fontSize: '12px' }} className="mb-3">
            {loadingStep}
          </span>
          <LinearProgress variant="determinate" value={typeof loadingProgress === 'number' ? loadingProgress : 100} />
        </Box>
      )}
      {(loadingProgress === 0 || showSpinner) && (
        <LoadingSpinner>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </LoadingSpinner>
      )}
    </div>
  );
};

export default LoadingProgress;
